/**
 * Created by Mikhail Menshenin on 19.03.2026
 */

HideAnimations = function (f) {
    this.node.hideAnimation && this.node.hideAnimation(f) || f();
};